module.exports = __webpack_public_path__ + "img/logo-color.030d3d9e.png";